<template><div></div></template>

<script>
export default {
  name: "MyPaymentCards",
};
</script>

<style scoped></style>
